import { useId } from "react";
import styles from "./SearchSection.module.css";
import PropTypes, { node } from "prop-types";
import Button from "../InputControls/Button";
import { createSectionTableLayout } from "../Utils/sectionControlUtil";
import { existChk } from "@maxis/client-logic/utils/controlsUtil";
import styles1 from "../Utils/sectionControlUtil.module.css";

/**
 * 조회 영역 Container
 * 자식 노드가 있는 경우, 자식 노드를 렌더링함 (일반적으로 <table> 태그로 시작)
 * 자식 노드가 없는 경우, searchControls의 형태에 따라 렌더링
 * @returns
 */
function SearchSection(props) {
  const key = useId();

  if (props.children) {
    return <div className={styles.searchSection}>{props.children}</div>;
  }

  // --- 수정된 부분: options 객체에 type: "search"를 추가하여 전달합니다. ---
  const searchOptions = {
    ...props.searchOptions,
    type: "search",
  };

  const rowsJsx = createSectionTableLayout(
    props.searchControls,
    props.numOfCols,
    searchOptions
  );
  // ------------------------------------------------------------------

  const trsJsx = rowsJsx?.map((tds, index) => (
    <div className={styles1.search_row} key={index}>
      {tds}
    </div>
  )); // tr 부분

  return (
    <div className={styles.searchSection}>
      <div className={styles.controlArea}>
        <div className="search_tbl">
          {" "}
          {/* table 부분 */}
          {trsJsx}
        </div>
      </div>

      <div
        className={`${styles.areaBtn} ${
          props.btnAlign === "right"
            ? styles.right
            : props.btnAlign === "center"
            ? styles.center
            : props.btnAlign === "left"
            ? styles.left
            : ""
        } `}
      >
        {props.btnSearch && existChk(props.btnSearch) ? (
          <>
            {props.additionalBtns ? props.additionalBtns : null}
            <Button
              key={useId()}
              {...(props.btnSearch.ref && { ref: props.btnSearch.ref })}
              buttonType={"search"}
              authBtn={props.btnSearch.authBtn ?? "SEARCH"}
              onClick={props.btnSearch.onClick}
              label={props.btnSearch.label ?? "조회"}
              checkAuth={props.btnSearch.checkAuth}
              colorType={props.btnSearch.colorType}
              iconType={props.btnSearch.iconType}
            />
            {props.additionalRightBtns ? props.additionalRightBtns : null}
          </>
        ) : props.additionalRightBtns ? (
          props.additionalRightBtns
        ) : null}
      </div>
    </div>
  );
}

SearchSection.defaultProps = {
  numOfCols: 3,
  btnAlign: "left",
  checkAuth: false,
  buttonAlignIsRight: false,
};

SearchSection.propTypes = {
  children: PropTypes.node,
  searchControls: PropTypes.object,
  numOfCols: PropTypes.number,
  btnSearch: PropTypes.object,
  btnAlign: PropTypes.string,
  additionalBtns: PropTypes.arrayOf(node),
  additionalRightBtns: PropTypes.arrayOf(node),
  checkAuth: PropTypes.bool,
};

export default SearchSection;